import type { Client, RequestContext } from "../client";
import type { DataContext, MetadataTypeCollection } from "../resources/dynamicFormResources";

export class CloudTemplateRepository {
    private client: Client;
    constructor(
        client: Client,
        private readonly requestContext: RequestContext
    ) {
        this.client = client;
    }

    getMetadata(templateBody: string, id: string): Promise<{ Metadata: MetadataTypeCollection; Values: DataContext }> {
        const templateResource: { template: string } = { template: encodeURI(templateBody) };
        return this.client.post<{ Metadata: MetadataTypeCollection; Values: DataContext }>(this.requestContext, this.client.getLink("CloudTemplate"), templateResource, { id: id.toString() });
    }
}
